import { useState, useEffect } from 'react';

interface GenericEditModalProps {
  isOpen: boolean;
  onClose: () => void;
  tableName: string;
  rowData: any; // The data of the row being edited (or empty for new)
  onSave: (tableName: string, data: any) => void;
}

const GenericEditModal = ({ isOpen, onClose, tableName, rowData, onSave }: GenericEditModalProps) => {
  const [editedData, setEditedData] = useState(rowData);

  useEffect(() => {
    setEditedData(rowData);
  }, [rowData]);

  if (!isOpen) return null;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setEditedData({ ...editedData, [name]: value });
  };

  const handleSubmit = () => {
    onSave(tableName, editedData);
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-75 flex justify-center items-center z-50 p-4">
      <div className="bg-gray-900 p-8 rounded-lg shadow-2xl w-full max-w-lg border border-gray-700 transform transition-all scale-100 opacity-100 duration-300 ease-out">
        <h2 className="text-3xl font-extrabold mb-6 text-white text-center">{rowData.id ? 'Edit' : 'Create'} Record in {tableName}</h2>
        <form>
          {Object.keys(rowData).map((key) => {
            // Skip primary key for creation, but allow editing
            if (key === 'id' && !rowData.id) return null;
            return (
              <div className="mb-4" key={key}>
                <label className="block text-gray-300 text-sm font-semibold mb-2" htmlFor={key}>
                  {key.replace(/_/g, ' ').replace(/([A-Z])/g, ' $1').trim()}:
                </label>
                <input
                  type={key.includes('password') ? 'password' : 'text'} // Basic type inference
                  id={key}
                  name={key}
                  value={editedData[key] || ''}
                  onChange={handleChange}
                  className="shadow-sm appearance-none border border-gray-600 rounded w-full py-2 px-3 text-gray-100 leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-gray-700"
                />
              </div>
            );
          })}
        </form>
        <div className="flex items-center justify-end mt-8 space-x-4">
          <button
            onClick={onClose}
            className="bg-red-600 hover:bg-red-700 text-white font-bold py-2 px-4 rounded-lg focus:outline-none focus:shadow-outline transition duration-150 ease-in-out"
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-lg focus:outline-none focus:shadow-outline transition duration-150 ease-in-out"
          >
            Save Changes
          </button>
        </div>
      </div>
    </div>
  );
};

export default GenericEditModal;
